<template>
  <div class="site-title">
    <a href="/" aria-label="Grid Resource Interconnection Portal">
      <SiteLogo />
    </a>
    <h1 class="h2">Grid Resource<br> Interconnection Portal</h1>
  </div>
</template>

<script setup>
import SiteLogo from './SiteLogo.vue'
</script>
